/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { variationsCreateGlobal } from "../funcs/variationsCreateGlobal.js";
import { variationsDeleteGlobal } from "../funcs/variationsDeleteGlobal.js";
import { variationsListGlobal } from "../funcs/variationsListGlobal.js";
import { variationsListGroups } from "../funcs/variationsListGroups.js";
import { variationsUpsertGlobal } from "../funcs/variationsUpsertGlobal.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { DeleteGlobalToolVariationResult } from "../models/components/deleteglobaltoolvariationresult.js";
import { ListToolVariationGroupsResult } from "../models/components/listtoolvariationgroupsresult.js";
import { ListVariationsResult } from "../models/components/listvariationsresult.js";
import { ToolVariationGroupResult } from "../models/components/toolvariationgroupresult.js";
import { UpsertGlobalToolVariationResult } from "../models/components/upsertglobaltoolvariationresult.js";
import {
  CreateGlobalToolVariationGroupRequest,
  CreateGlobalToolVariationGroupSecurity,
} from "../models/operations/createglobaltoolvariationgroup.js";
import {
  DeleteGlobalVariationRequest,
  DeleteGlobalVariationSecurity,
} from "../models/operations/deleteglobalvariation.js";
import {
  ListGlobalVariationsRequest,
  ListGlobalVariationsSecurity,
} from "../models/operations/listglobalvariations.js";
import {
  ListToolVariationGroupsRequest,
  ListToolVariationGroupsSecurity,
} from "../models/operations/listtoolvariationgroups.js";
import {
  UpsertGlobalVariationRequest,
  UpsertGlobalVariationSecurity,
} from "../models/operations/upsertglobalvariation.js";
import { unwrapAsync } from "../types/fp.js";

export class Variations extends ClientSDK {
  /**
   * createGlobal variations
   *
   * @remarks
   * Ensure the project-default (global) tool variation group exists, returning it. Idempotent: returns the existing group unchanged when present, otherwise creates it. Takes no parameters and only manages the single project-default group.
   */
  async createGlobal(
    request?: CreateGlobalToolVariationGroupRequest | undefined,
    security?: CreateGlobalToolVariationGroupSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ToolVariationGroupResult> {
    return unwrapAsync(variationsCreateGlobal(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteGlobal variations
   *
   * @remarks
   * Create or update a globally defined tool variation.
   */
  async deleteGlobal(
    request: DeleteGlobalVariationRequest,
    security?: DeleteGlobalVariationSecurity | undefined,
    options?: RequestOptions,
  ): Promise<DeleteGlobalToolVariationResult> {
    return unwrapAsync(variationsDeleteGlobal(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listGlobal variations
   *
   * @remarks
   * List globally defined tool variations.
   */
  async listGlobal(
    request?: ListGlobalVariationsRequest | undefined,
    security?: ListGlobalVariationsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListVariationsResult> {
    return unwrapAsync(variationsListGlobal(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listGroups variations
   *
   * @remarks
   * List the tool variation groups visible to the project. In v1 this returns the project-default group when it exists, or an empty list otherwise.
   */
  async listGroups(
    request?: ListToolVariationGroupsRequest | undefined,
    security?: ListToolVariationGroupsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListToolVariationGroupsResult> {
    return unwrapAsync(variationsListGroups(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * upsertGlobal variations
   *
   * @remarks
   * Create or update a globally defined tool variation.
   */
  async upsertGlobal(
    request: UpsertGlobalVariationRequest,
    security?: UpsertGlobalVariationSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UpsertGlobalToolVariationResult> {
    return unwrapAsync(variationsUpsertGlobal(
      this,
      request,
      security,
      options,
    ));
  }
}
